/*
 * Adele Chérie — Strenne Natale B2B
 * Gestisce la selezione prodotti nel catalogo e il riepilogo nel modulo di preventivo.
 * Tutto avviene sulla stessa pagina (catalogo + form), stato tenuto in memoria + localStorage
 * (localStorage solo per sopravvivere a un refresh accidentale della pagina).
 */
(function () {
  var STORAGE_KEY = 'ac_b2b_natale_selection';

  function loadSelection() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveSelection(selection) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
    } catch (e) {
      /* localStorage non disponibile: la selezione resta comunque in memoria per questa sessione di pagina */
    }
  }

  var selection = loadSelection();

  function formatEuro(n) {
    return '€' + (Math.round((Number(n) || 0) * 100) / 100).toFixed(2).replace('.', ',');
  }

  function renderSelection() {
    var list = document.getElementById('ac-b2b-selection-list');
    var empty = document.getElementById('ac-b2b-selection-empty');
    var hiddenField = document.getElementById('ac-b2b-prodotti-selezionati');
    if (!list) return;

    list.innerHTML = '';

    if (selection.length === 0) {
      if (empty) empty.style.display = '';
    } else {
      if (empty) empty.style.display = 'none';
      selection.forEach(function (item, index) {
        var qty = Math.max(1, parseInt(item.qty, 10) || 1);
        var subtotal = qty * (item.priceRaw || 0);

        var li = document.createElement('li');
        li.className = 'ac-b2bform__selection-item';

        var info = document.createElement('span');
        info.className = 'ac-b2bform__selection-info';
        info.textContent = item.title + (item.personalizzabile === 'true' ? ' (personalizzabile)' : '') + ' — ' + item.price + ' cad.';
        li.appendChild(info);

        var qtyWrap = document.createElement('span');
        qtyWrap.className = 'ac-b2bform__selection-qty';

        var minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'ac-b2bform__selection-qty-btn';
        minusBtn.setAttribute('aria-label', 'Diminuisci quantità di ' + item.title);
        minusBtn.textContent = '−';
        minusBtn.addEventListener('click', function () {
          selection[index].qty = Math.max(1, qty - 1);
          saveSelection(selection);
          renderSelection();
        });
        qtyWrap.appendChild(minusBtn);

        var qtyInput = document.createElement('input');
        qtyInput.type = 'number';
        qtyInput.min = '1';
        qtyInput.className = 'ac-b2bform__selection-qty-input';
        qtyInput.value = qty;
        qtyInput.setAttribute('aria-label', 'Quantità di ' + item.title);
        qtyInput.addEventListener('change', function () {
          selection[index].qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
          saveSelection(selection);
          renderSelection();
        });
        qtyWrap.appendChild(qtyInput);

        var plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'ac-b2bform__selection-qty-btn';
        plusBtn.setAttribute('aria-label', 'Aumenta quantità di ' + item.title);
        plusBtn.textContent = '+';
        plusBtn.addEventListener('click', function () {
          selection[index].qty = qty + 1;
          saveSelection(selection);
          renderSelection();
        });
        qtyWrap.appendChild(plusBtn);

        li.appendChild(qtyWrap);

        var subtotalEl = document.createElement('span');
        subtotalEl.className = 'ac-b2bform__selection-subtotal';
        subtotalEl.textContent = formatEuro(subtotal);
        li.appendChild(subtotalEl);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'ac-b2bform__selection-remove';
        removeBtn.setAttribute('aria-label', 'Rimuovi ' + item.title);
        removeBtn.textContent = '×';
        removeBtn.addEventListener('click', function () {
          selection.splice(index, 1);
          saveSelection(selection);
          renderSelection();
          updateAddButtons();
        });
        li.appendChild(removeBtn);

        list.appendChild(li);
      });
    }

    if (hiddenField) {
      hiddenField.value = selection
        .map(function (item) {
          var qty = Math.max(1, parseInt(item.qty, 10) || 1);
          return qty + 'x ' + item.title + ' — ' + item.price + ' cad. — subtotale ' + formatEuro(qty * (item.priceRaw || 0));
        })
        .join('\n');
    }
  }

  function updateAddButtons() {
    var buttons = document.querySelectorAll('[data-ac-b2b-add]');
    buttons.forEach(function (btn) {
      var card = btn.closest('[data-product-handle]');
      var handle = card ? card.getAttribute('data-product-handle') : null;
      var already = selection.some(function (item) { return item.handle === handle; });
      var labelEl = btn.querySelector('[data-ac-b2b-add-label]');
      if (labelEl) {
        labelEl.textContent = already ? 'Aggiunto al preventivo' : 'Aggiungi al preventivo';
      }
      btn.classList.toggle('is-added', already);
    });
  }

  document.addEventListener('click', function (event) {
    var qtyBtn = event.target.closest('[data-ac-b2b-qty-btn]');
    if (qtyBtn) {
      var card = qtyBtn.closest('[data-product-handle]');
      var input = card && card.querySelector('[data-ac-b2b-qty-input]');
      if (input) {
        var current = Math.max(1, parseInt(input.value, 10) || 1);
        var delta = qtyBtn.getAttribute('data-ac-b2b-qty-btn') === '+1' ? 1 : -1;
        input.value = Math.max(1, current + delta);
      }
      return;
    }

    var btn = event.target.closest('[data-ac-b2b-add]');
    if (!btn) return;

    var card = btn.closest('[data-product-handle]');
    var handle = card ? card.getAttribute('data-product-handle') : null;
    if (!handle) return;

    var already = selection.some(function (item) { return item.handle === handle; });
    if (already) return;

    var qtyInput = card.querySelector('[data-ac-b2b-qty-input]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    selection.push({
      handle: handle,
      title: btn.getAttribute('data-title'),
      price: btn.getAttribute('data-price'),
      priceRaw: parseFloat(btn.getAttribute('data-price-raw')) || 0,
      personalizzabile: btn.getAttribute('data-personalizzabile'),
      image: btn.getAttribute('data-image') || '',
      qty: qty
    });
    saveSelection(selection);
    renderSelection();
    updateAddButtons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    renderSelection();
    updateAddButtons();
  });

  var form = document.getElementById('ac-b2b-form');
  if (form) {
    var alreadySubmitting = false;

    form.addEventListener('submit', function (event) {
      renderSelection();

      if (alreadySubmitting) return; // secondo submit (dopo form.submit() nativo): lascialo passare

      var section = document.getElementById('ac-b2b-preventivo');
      var endpoint = section && section.getAttribute('data-ac-b2b-endpoint');
      var data = new FormData(form);
      var isBot = !!data.get('contact[hp_check_9f3a]'); // honeypot: se compilato, probabile bot (o autofill del browser)

      if (!endpoint || isBot) {
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        return; // nessun servizio PDF configurato: procede col submit nativo normale
      }

      // Blocchiamo il submit nativo finché il servizio PDF non ha risposto
      // (o non scade il timeout): una fetch cross-origin in parallelo alla
      // navigazione della pagina può essere interrotta dal browser prima
      // che il preflight CORS finisca, perdendo silenziosamente la richiesta.
      event.preventDefault();

      var submitBtn = form.querySelector('.ac-b2bform__submit');
      var originalLabel = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Invio in corso…';
      }

      var payload = {
        companyName: data.get('contact[ragione_sociale]') || '',
        vat: data.get('contact[piva]') || '',
        contactName: data.get('contact[name]') || '',
        email: data.get('contact[email]') || '',
        phone: data.get('contact[telefono]') || '',
        billingAddress: data.get('contact[indirizzo_fatturazione]') || '',
        recipientsCount: data.get('contact[numero_destinatari]') || '',
        notes: data.get('contact[note]') || '',
        items: selection.map(function (item) {
          return {
            title: item.title,
            price: item.priceRaw || 0,
            quantity: Math.max(1, parseInt(item.qty, 10) || 1),
            personalizzabile: item.personalizzabile === 'true',
            image: item.image || ''
          };
        })
      };

      var proceeded = false;
      function proceedToNativeSubmit() {
        if (proceeded) return;
        proceeded = true;
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        alreadySubmitting = true;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        }
        form.submit(); // non ri-scatena l'evento 'submit': niente loop
      }

      var timeoutId = setTimeout(proceedToNativeSubmit, 9000);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () {}).then(function () {
        clearTimeout(timeoutId);
        proceedToNativeSubmit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFilters();
    initViewControls();
  });

  function initViewControls() {
    var container = document.querySelector('.ac-b2bnat__products');
    if (!container) return;

    var viewBtns = document.querySelectorAll('[data-ac-b2b-view]');
    var colsSelect = document.getElementById('ac-b2b-filter-cols');
    var colsField = colsSelect ? colsSelect.closest('.ac-b2bnat__filter--cols') : null;
    var VIEW_KEY = 'ac_b2b_natale_view';
    var COLS_KEY = 'ac_b2b_natale_cols';

    function applyView(view) {
      container.classList.toggle('is-list-view', view === 'list');
      viewBtns.forEach(function (btn) {
        var active = btn.getAttribute('data-ac-b2b-view') === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (colsField) colsField.style.display = view === 'list' ? 'none' : '';
    }

    function applyCols(cols) {
      container.setAttribute('data-cols', cols);
    }

    var savedView = 'grid';
    var savedCols = '4';
    try {
      savedView = window.localStorage.getItem(VIEW_KEY) || 'grid';
      savedCols = window.localStorage.getItem(COLS_KEY) || '4';
    } catch (e) {}

    applyView(savedView);
    applyCols(savedCols);
    if (colsSelect) colsSelect.value = savedCols;

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-ac-b2b-view');
        applyView(view);
        try { window.localStorage.setItem(VIEW_KEY, view); } catch (e) {}
      });
    });

    if (colsSelect) {
      colsSelect.addEventListener('change', function () {
        applyCols(colsSelect.value);
        try { window.localStorage.setItem(COLS_KEY, colsSelect.value); } catch (e) {}
      });
    }
  }

  function initFilters() {
    var priceSelect = document.getElementById('ac-b2b-filter-price');
    var persoCheckbox = document.getElementById('ac-b2b-filter-personalizzabile');
    var emptyMsg = document.getElementById('ac-b2b-filter-empty');
    var cards = document.querySelectorAll('.ac-b2bcard');
    if (!cards.length || (!priceSelect && !persoCheckbox)) return;

    function applyFilters() {
      var range = priceSelect ? priceSelect.value : '';
      var min = null;
      var max = null;
      if (range) {
        var parts = range.split('-');
        min = parts[0] !== '' ? parseFloat(parts[0]) : null;
        max = parts[1] !== '' ? parseFloat(parts[1]) : null;
      }
      var onlyPerso = persoCheckbox && persoCheckbox.checked;
      var visibleCount = 0;

      cards.forEach(function (card) {
        var price = parseFloat(card.getAttribute('data-price')) || 0;
        var perso = card.getAttribute('data-personalizzabile') === 'true';
        var ok = true;
        if (min !== null && price < min) ok = false;
        if (max !== null && price > max) ok = false;
        if (onlyPerso && !perso) ok = false;
        card.style.display = ok ? '' : 'none';
        if (ok) visibleCount++;
      });

      if (emptyMsg) emptyMsg.style.display = visibleCount === 0 ? '' : 'none';
    }

    if (priceSelect) priceSelect.addEventListener('change', applyFilters);
    if (persoCheckbox) persoCheckbox.addEventListener('change', applyFilters);
  }
})();
